import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IGoal } from '../../major_explorer_interface';

interface IListSelectionModel {
  subjectinterestSorted: IGoal[];
  activityinterestSorted: IGoal[];
  listselections: { max_interests: number };
}
interface IListSelectionFunctionModel {
  programs: IListSelectionModel;
  questionList: IGoal[];
}

export class ListselectionQuestionFunction {
  models: IListSelectionFunctionModel;
  private programsCache: IListSelectionModel;
  private isSecondPage: boolean;

  constructor(
    private loadListSelectionCommand: ICommand,
    private saveListSelectionSubjectCommand: ICommand,
    private saveListSelectionActivityCommand: ICommand,
    private myIntakeHistoryModel: any,
    private ItemPresenterEnum: any,
    private myIntakeModel: any,
    private $q: ng.IQService
  ) {}

  initialize(): void {
    this.isSecondPage = this.myIntakeModel.progression.isSecondListSelectionPage();
    this.models = {} as IListSelectionFunctionModel;

    if (!this.programsCache) {
      this.loadListSelectionCommand().then((model: IListSelectionModel) => {
        this.models.programs = model;
        this.programsCache = model;
        this.getInterestViewModel(model);

        const selected = this.filterSelected(model.subjectinterestSorted, model.activityinterestSorted);
        this.myIntakeHistoryModel.update(
          this.ItemPresenterEnum.LISTSELECTION.key,
          selected.selectedsubject.concat(selected.selectedactivity)
        );
      });
    } else {
      this.models.programs = this.programsCache;
      this.getInterestViewModel(this.programsCache);
    }
  }

  validate(brokenUpAndPageTwo?: boolean) {
    // only check if there are options to validate, else presenter defaults to valid
    if (
      _4.isUndefined(this.models.programs) ||
      _4.isEmpty(this.sortedActivityInterests) ||
      _4.isEmpty(this.sortedSubjectInterests)
    ) {
      return true;
    }

    const selectedsubject = _4.find(this.sortedSubjectInterests, { _selected: true });
    const selectedactivity = _4.find(this.sortedActivityInterests, { _selected: true });

    let isValid = false;

    if (_4.isUndefined(brokenUpAndPageTwo)) {
      isValid = !_4.isEmpty(selectedsubject) && !_4.isEmpty(selectedactivity);
    } else if (!brokenUpAndPageTwo) {
      isValid = !_4.isEmpty(selectedsubject);
    } else if (brokenUpAndPageTwo) {
      isValid = !_4.isEmpty(selectedactivity);
    }

    return isValid;
  }

  item_onChange() {
    const selected = this.filterSelected(this.sortedSubjectInterests, this.sortedActivityInterests);
    this.myIntakeHistoryModel.update(
      this.ItemPresenterEnum.LISTSELECTION.key,
      selected.selectedsubject.concat(selected.selectedactivity)
    );
    return this.$q.all([
      this.saveListSelectionSubjectCommand(this.sortedSubjectInterests),
      this.saveListSelectionActivityCommand(this.sortedActivityInterests)
    ]);
  }

  hasSelectedMaximumInterests(collection: IGoal[]): boolean {
    const maxInterests = this.models.programs ? this.models.programs.listselections.max_interests : 3;
    if (!this.models.programs || !maxInterests) {
      return false;
    }

    return (
      _4.size(
        _4.filter(collection, (interest: IGoal) => {
          return interest._selected;
        })
      ) >
      maxInterests - 1
    );
  }

  isActivityDisabled(interest: IGoal): boolean {
    return this.hasSelectedMaximumInterests(this.sortedActivityInterests) && !interest._selected;
  }

  isSubjectDisabled(interest: IGoal) {
    return this.hasSelectedMaximumInterests(this.sortedSubjectInterests) && !interest._selected;
  }

  getInterestViewModel(model: any) {
    this.models.questionList = [];
    if (!_4.isUndefined(this.isSecondPage) && this.isSecondPage) {
      this.models.questionList = model.activityinterestSorted;
    } else if (!_4.isUndefined(this.isSecondPage)) {
      this.models.questionList = model.subjectinterestSorted;
    }
  }

  private filterSelected(subjectinterestSorted: IGoal[], activityinterestSorted: IGoal[]) {
    return {
      selectedsubject: _4.filter(subjectinterestSorted, (item: IGoal) => item._selected),
      selectedactivity: _4.filter(activityinterestSorted, (item: IGoal) => item._selected)
    };
  }

  get sortedSubjectInterests(): IGoal[] {
    return _4.get(this.models, 'programs.subjectinterestSorted', []);
  }

  get sortedActivityInterests(): IGoal[] {
    return _4.get(this.models, 'programs.activityinterestSorted', []);
  }
}

angular.module('major-explorer-data').service('listselectionQuestionFn', ListselectionQuestionFunction);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/functions/list_selection_fn.ts